<template>
  <b-row :style="white ? '' : 'background-image: url(/static-appopensalud/img/bgs/opt/fondogris.jpg),linear-gradient(to top, #eee, transparent)'" class="centered d-flex neu-cards-slider mx-auto" :class="{ 'black': black }">
    <!-- <div class="background-pricing"></div> -->
    <b-col style="margin-top: 3rem !important;" cols="12" class="text-center my-auto pt-5 pb-sm-5">
      <h3>{{ title }}</h3> {{iva}}
    </b-col>
    <div>
      <b-col v-for="card in cards" :key="cards[card]" md="12" class="card-ctn2">
        <div>
          <neu-card-pricing-prime :id="card.id" :black="black" :text="card.text" :priceSubtitle="card.priceSubtitle" :priceTitle="card.priceTitle" :subtitle="card.subtitle" :subtitle1="card.subtitle1" :subtitle2="card.subtitle2" :title="card.title" :titleLines="card.titleLines" :subtitleLines="card.subtitleLines"></neu-card-pricing-prime>
        </div>
      </b-col>
    </div>
    <div>
      <b-col v-for="card in cards2" :key="cards[card]" md="12" class="card-ctn2">
        <div>
          <neu-card-pricing-prime :id="card.id" :black="black" :text="card.text" :priceSubtitle="card.priceSubtitle" :priceTitle="card.priceTitle" :subtitle="card.subtitle" :subtitle1="card.subtitle1" :subtitle2="card.subtitle2" :title="card.title" :titleLines="card.titleLines" :subtitleLines="card.subtitleLines"></neu-card-pricing-prime>
        </div>
      </b-col>
    </div>
    <div>
      <b-col v-for="card in cards3" :key="cards[card]" md="12" class="card-ctn2">
        <div>
          <neu-card-pricing-prime :id="card.id" :black="black" :text="card.text" :priceSubtitle="card.priceSubtitle" :priceTitle="card.priceTitle" :subtitle="card.subtitle" :subtitle1="card.subtitle1" :subtitle2="card.subtitle2" :title="card.title" :titleLines="card.titleLines" :subtitleLines="card.subtitleLines"></neu-card-pricing-prime>
        </div>
      </b-col>
    </div>
    <b-col style="margin-top: 5rem !important;" cols="12" class="text-center my-auto pt-lg-0 pt-5 pb-sm-5">
        <iframe v-if="!$uiHelpers.isMobile" width="600" height="315" src="https://www.youtube.com/embed/pVWnBU3Pxe8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <iframe v-if="$uiHelpers.isMobile" width="300" height="315" src="https://www.youtube.com/embed/pVWnBU3Pxe8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </b-col>
    <b-col cols="12" class="text-center pb-5 pb-md-0" v-if="hasConditionsSlot">
        <slot name="conditions">
        </slot>
      </b-col>
  </b-row>

</template>

<script>
import NeuCardPricingPrime from './NeuCardPricingPrime.vue'
import BaseModal from '../BaseModal.vue'
import BaseDialog from '@/components/base/BaseDialog.vue'
import opensaludprimeMixin from '@/mixins/opensaludprime.mixin'

const messages = {
  es: {
    'register-free': '¡Regístrate y pruébalo gratis durante 6 meses sin compromiso!',
    'register-free-openlegal': '¡Regístrate y pruébalo gratis durante 3 meses sin compromiso!'
  },
  en: {
    'register-free': 'Register and try it for free for 6 meses with no obligation!',
    'register-free-openlegal': 'Register and try it for free for 3 months with no obligation!'
  }
}

export default {
  name: 'neu-cards-slider-pricing-prime',
  mixins: [opensaludprimeMixin],
  i18n: {
    messages
  },
  components: {
    'base-button': () => import('@/components/base/buttons/BaseButton'),
    'patient-signup-form': () => import('@/components/forms/PatientSignupForm'),
    BaseModal,
    NeuCardPricingPrime,
    BaseDialog
  },
  data () {
    return {
      dialogVideo: false
    }
  },
  props: {
    cards: {
      type: Array,
      required: true
    },
    cards2: {
      type: Array,
      required: true
    },
    cards3: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
     iva: {
      type: String,
      required: true
    },
    black: {
      type: Boolean,
      required: false,
      default: false
    },
    white: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
     goToVideo () {
      // window.location = 'https://www.youtube.com/watch?v=pVWnBU3Pxe8&t=4s&ab_channel=opensalud'
      this.dialogVideo = true
     }
  },
  computed: {
    hasConditionsSlot () {
      return !!this.$slots.conditions
    }
  }
}
</script>

<style lang="scss">
/*.background-pricing {
    animation: fade-in 2s ease-in;

    background-position-y: center;
    position: absolute;
    z-index: -1;
    height: 100%;
    background-repeat: no-repeat;
    width: 100%;
    left: 0;
    transition: all .5s ease;
    background-size: cover;

    @include desktop {
      background-image: url('/static-appopensalud/img/bgs/opt/fondogris.jpg'), linear-gradient(to right, $gray, transparent);
      background-position-x: 2px;
      

    background-image: url('/static/img/bgs/opt/employees2.webp'), linear-gradient(to right, $white, transparent); 
      background-blend-mode: overlay;
      
    }
    @include desktop-sm {
      background-image: url('/static-appopensalud/img/bgs/opt/fondogris.jpg'), linear-gradient(to right, $gray, transparent);
      background-blend-mode: overlay;

      width: 100%;
      @include main-block-height();
      background-size: cover;
      background-position: top;
    }
    @include tablets {
      background-image: url('/static-appopensalud/img/bgs/opt/fondogris.jpg'), linear-gradient(to top, $white, transparent);
      background-blend-mode: overlay;
      background-position-x: center;
      width: 100%;
      background-size: cover;
            background-position: top;
            background-blend-mode: overlay;
            height: 100%;
            background-repeat: no-repeat;
    }
    @include mobile {
      background-image: url('/static-appopensalud/img/bgs/opt/fondogris.jpg'), linear-gradient(to top, $white, transparent);
      background-position-x: 60%;
      background-size: cover;
      background-blend-mode: overlay;
      height: 100%;
      background-repeat: no-repeat;
      width: 100%;
      z-index: -1;
    }
  }*/
  h3 {
    color: $blue;
  }

  .black {
    background-color: $black;
  }

  .neu-cards-slider {
    &:not(.black) {
      background-repeat: no-repeat;
      background-size: cover;
      background-position-y: center;
    }
    
    justify-content: center;
    .btn{
      @include desktop {
        margin-top: 3%

      }
      
    }
    @include tablets {
      .row {
        display: contents;
        overflow-x: hidden;
        overflow-y: hidden;
        white-space: nowrap;

        [class*="col-"] {
          display: inline-block;
          width: 100%;
          // margin-right: 50%;
        }
      }
    }
    @include mobile {
      .row {
        display: contents;
        overflow-x: hidden;
        overflow-y: hidden;
        white-space: nowrap;

        [class*="col-"] {
          display: inline-block;
          width: 100%;
          @media screen and (max-width: 320px) {
          margin-right: 50%;
        }
        @media screen and (min-width: 321px) and (max-width: 425px) {
          margin-left: 2%;
        }
        }
      }
    }

    @include media(tablets,mobile) {
      .row {
        margin-bottom: 2rem;
        margin-block-end: 5rem;

        &::-webkit-scrollbar {
          height: 3px;
        }
        
        &::-webkit-scrollbar-track {
          background-color: $gray-600;
          border-radius: 100px;
        }
        
        &::-webkit-scrollbar-thumb {
          background-color: $black;
          border-radius: 100px;
        }

        span {
          white-space: normal;
        }
      }
    }
 .card-ctn2 {
      display: flex;

      @include desktop {
        padding: 0 2rem;
      }
      @include desktop-sm {
        padding: 0 2rem;
      }
      @include tablets {
        padding: 0;
      }
      @include media(tablets, mobile) {
        padding-right: 4rem;
        padding-left: 4rem;
        padding-top: 4rem;
        padding-bottom: 2rem;
      }
      
      .neu-card {
        width:20rem;
            transition-duration: 9999999s;
            justify-content:center ;
        &:hover {
            @include desktop {
                padding: 5rem;
            }
            @include desktop-sm {
              padding: 2rem 5rem;
            }
      
      transition-duration: 999999999s;
      }
        @include desktop {
          display: block;
          padding: 5rem;
          height: 470px;
          width: 320px;
        }
        @include desktop-sm {
          display: flex;
          padding: 3rem 5rem;
          height: 400px;
          width: 320px;
        }

        @include tablets {
          display: table-cell;
          padding: 7rem;
          width: 100%;
          max-width: none;

          span{
            margin: auto;
          }
        }

        @include mobile {
                    display: block;

          padding: 5rem 3rem;
          margin-bottom: 3rem;
          min-height: 280px;
        }
      }
      
    }
    .card-ctn {
      display: flex;

      @include desktop {
        padding: 0 7rem;
      }
      @include desktop-sm {
        padding: 0 2rem;
      }
      @include tablets {
        padding: 0;
      }
      @include media(tablets, mobile) {
        margin-right: 5rem;
        padding-right: 4rem;
        padding-left: 4rem;
        padding-top: 4rem;
        padding-bottom: 2rem;
      }

      .neu-card {
        display: flex;
        @include desktop {
          padding: 5rem;
          min-height: 400px;
          max-width: 350px;
        }
        @include desktop-sm {
          padding: 2rem 5rem;
          min-height: 300px;
          max-width: 250px;
        }

        @include tablets {
          padding: 7rem;
          width: 100%;
          max-width: 250px;

          span {
            margin: auto;
          }
        }

        @include mobile {
          padding: 5rem 3rem;
          margin-bottom: 3rem;
          min-height: 280px;
        }
      }
      .neu-card-rates {
        display: flex;
        @include desktop {
          padding: 5rem;
          min-height: 500px;
          max-width: 220px;
        }
        @include desktop-sm {
          padding: 2rem 5rem;
          min-height: 300px;
          max-width: 250px;
        }

        @include tablets {
          padding: 7rem;
          width: 100%;
          max-width: none;

          span {
            margin: auto;
          }
        }

        @include mobile {
          padding: 5rem 3rem;
          margin-bottom: 3rem;
          min-height: 280px;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/base/ui/NeuCardsSliderPricingPrime.vue